export default {"src":"/_next/static/media/docs-icon.4364b62b.svg","height":30,"width":35,"blurWidth":0,"blurHeight":0};